import * as React from 'react';
import { MultiSelect } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { CardsChoseQuestion } from '../../components/CardsQuestion';
import { MULTI_SELECT_RENDER_CRITERIA } from './constants/multiSelectRenderCriteria';
import { useMultiselectControls } from './utils/useMultiSelectControls';
import { useCardsAsCheckboxesControls } from './utils/useCardsAsCheckboxesControls';
import { jsx as _jsx } from "react/jsx-runtime";
export var CardsChoseQuestionContainer = function CardsChoseQuestionContainer(props) {
  var answers = props.answers,
      placeholder = props.placeholder,
      subType = props.subType;
  var isDesktop = useDeviceType() === 'desktop';

  var _useCardsAsCheckboxes = useCardsAsCheckboxesControls(props),
      handleSelectCard = _useCardsAsCheckboxes.handleSelectCard,
      value = _useCardsAsCheckboxes.value;

  var _useMultiselectContro = useMultiselectControls(props),
      handleMultiSelect = _useMultiselectContro.handleMultiSelect;

  if (!answers) {
    return null;
  }
  /**
   * При большом числе вариантов в мобильной версии неудобно работать с карточками
   * поэтому если число больше заданного - рендерим мультиселект
   *  **/


  var shouldRenderMultiSelect = !isDesktop && answers.length > MULTI_SELECT_RENDER_CRITERIA;

  if (shouldRenderMultiSelect) {
    return /*#__PURE__*/_jsx(MultiSelect, {
      value: value,
      placeholder: placeholder || 'Выберите значения',
      options: answers,
      onChange: handleMultiSelect
    });
  }

  return /*#__PURE__*/_jsx(CardsChoseQuestion, {
    value: value,
    handleSelect: handleSelectCard,
    iconType: subType,
    cards: answers
  });
};
CardsChoseQuestionContainer.displayName = 'CardsChoseQuestionContainer';